import { Injectable, signal, TemplateRef } from '@angular/core'

export interface Toast {
  type: 'success' | 'info' | 'warning' | 'error'
  message: string
  classname?: string
  delay?: number
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts = signal<Toast[]>([])

  show(toast: Toast) {
    this.toasts.update((toasts) => [...toasts, toast])
  }

  remove(toast: Toast) {
    this.toasts.update((toasts) => toasts.filter((t) => t !== toast))
  }

  clear() {
    this.toasts.set([])
  }
}
